<template>
  <div>
    <div v-for="item in contentItems" :key="item.id" :style="{'background-color': (item.id % 2 === 1) ? '#f7fbfa' : '#ffffff'}">
      <el-row class="content-wrapper">
        <el-col :xs="24" :sm="12" :lg="12" :style="{'float': (item.id % 2 === 1) ? 'left': 'right' }">
          <img :src="item.image">
        </el-col>
        <el-col :xs="24" :sm="12" :lg="12" class="text-wrapper" :style="{'float': (item.id % 2 === 0) ? 'left': 'right' }">
          <div class="content-text">
            <div class="main-content">{{ item.mainContent }}</div>
            <div class="sub-content">{{ item.subContent }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

  export default {
    props: [
      'contentItems'
    ],
    data () {
      return {}
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .content-wrapper {
    padding: 20px;
    margin: 0px auto !important;
    @media (min-width: 768px) {
      width: 100%;
    }
    @media (min-width: 1200px) {
      width: 1200px;
    }
  }

  .el-row {
    align-items: center;
    margin: 20px 0;
    .text-wrapper {
      height: 600px;
      position: relative;
      @media (max-width: 640px) {
        height: 100%;
      }
      .content-text {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        @media (max-width: 640px) {
          position: relative;
          top: auto;
          transform: translateY(0);
        }
        .main-content {
          padding: 20px;
          font-size: $font-size-extra-large;
          letter-spacing: 2px;
        }
        .sub-content {
          padding: 20px 20px;
          font-size: $font-size-h4;
          color: $color-text-default-light;
        }
      }
    }
    .el-col {
      img {
        width: 100%;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/y-text-img/y-text-img.vue